export const VIEW = {
  START_TODAY_APP: 'st-app',
};

export const VIEW_LIST = [
  VIEW.START_TODAY_APP,
];
